import React from "react";
import "./styles/App.css";
import Tetris from "./components/tetris/Tetris";

const App = () => (
  <div className="App">
    <Tetris />
  </div>
);

export default App;
